"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var comment_1 = __importDefault(require("./sub/comment"));
var link_1 = __importDefault(require("./sub/link"));
var main_media_1 = __importDefault(require("./sub/main-media"));
var logo_1 = __importDefault(require("./sub/logo"));
var title_1 = __importDefault(require("./sub/title"));
var description_1 = __importDefault(require("./sub/description"));
var transparencyButton_1 = __importDefault(require("./sub/transparencyButton"));
var NewConstruction = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native, grid = _a.grid, isBap = _a.isBap, vertical = _a.vertical;
    var bap = isBap || vertical === 'bap';
    return (React.createElement(React.Fragment, null,
        React.createElement(comment_1.default, { placement: "NewConstruction", adObj: adObj }),
        React.createElement("div", { "aria-owns": "result-item-heading-" + adObj.targetId }),
        React.createElement("div", { className: "ads__unit__img" },
            React.createElement("div", { className: "ads__unit__img__ratio img-format img-format--ratio3by2 img-format--crop-horizontal img-format--centered" },
                React.createElement(main_media_1.default, { native: native, className: "img-format__img" }))),
        React.createElement("div", { className: "ads__unit__content" },
            React.createElement("h2", { className: "ads__unit__content__title", id: "result-item-heading-" + adObj.targetId },
                React.createElement(link_1.default, { adObj: adObj, className: "ads__unit__link" },
                    React.createElement(title_1.default, { native: native }))),
            React.createElement("div", { className: "ads__unit__content__status u-position-relative" },
                React.createElement("span", { className: "status status--sponsored u-mb8" }, "Kommer for salg"),
                !bap && (React.createElement("div", { className: "u-position-absolute u-top u-right" },
                    React.createElement("div", { className: "button button--has-icon button--pill icon" },
                        React.createElement(transparencyButton_1.default, { adObj: adObj, style: {
                                position: 'relative',
                                right: '31px',
                                bottom: '15px',
                                filter: '',
                                transform: 'scaleY(1.2) scaleX(1.2)',
                            } }))))),
            React.createElement("p", null,
                React.createElement(description_1.default, { native: native, className: "u-float-left ads__unit__content__list" }),
                React.createElement(logo_1.default, { native: native, className: "u-float-right", style: { maxHeight: '40px', maxWidth: '75px' } }))),
        bap && (React.createElement("div", { className: "ads__unit__tools" },
            React.createElement("div", { className: "button button--has-icon button--pill icon" },
                React.createElement(transparencyButton_1.default, { adObj: adObj, style: {
                        position: 'relative',
                        right: '31px',
                        bottom: '15px',
                        filter: grid ? 'brightness(0) invert(1)' : '',
                        transform: 'scaleY(1.2) scaleX(1.2)',
                    } }))))));
};
exports.default = NewConstruction;
